<template>
<div>
  <div id="kpxxEdit" v-if="editFlag">
      <!--企业开票信息-->
      <div id="kpxxView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="kpxxForm" :model="kpxxForm" label-position="right" label-width="150px" :rules="kpxxRules">
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <el-form-item prop="kplx" label="开票类型" style="text-align: left">
                <el-radio-group v-model="kpxxForm.kplx" size="small" auto-complete="off" @change="fplxChange()">
                  <el-radio class="radio" :label="'1'">增值税专用发票</el-radio>
                  <el-radio class="radio" :label="'2'">增值税普通发票</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <el-form-item prop="kpgsmc" label="开票公司名称">
                <el-input size="small" v-model="kpxxForm.kpgsmc" placeholder="开票公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <el-form-item prop="tyshxydm" label="统一社会信用代码" :onkeyup="addBlankXydm()">
                <el-input size="small" v-model="kpxxForm.tyshxydm" placeholder="统一社会信用代码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <el-form-item prop="gsdz" label="公司地址" :rules="this.isZyfp?kpxxRules.gsdz:[{ required: false, message: '请输入公司地址', trigger: 'blur' },{ min: 1, max: 150, message: '最多可输入150个字', trigger: 'blur' }]">
                <el-input size="small" v-model="kpxxForm.gsdz" placeholder="公司地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5" v-show="isZyfp">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="5">
              <el-form-item prop="dhhmqh" label="电话号码" :rules="this.isZyfp?kpxxRules.dhhmqh:[{ required: false, message: '请输入区号', trigger: 'blur' }]">
                <el-input size="small" v-model="kpxxForm.dhhmqh" maxlength="10" placeholder="区号" style="width:90%;display:inline;float:left"></el-input>
                <div style="width:5%;display:inline;text-align: center">
                  <p style="font-size: 14px;color: #606266;line-height: 40px;">-</p>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="dhhm" label-width="0" :rules="this.isZyfp?kpxxRules.dhhm:[{ required: false, message: '请输入电话号码', trigger: 'blur' }]">
                <el-input size="small" v-model="kpxxForm.dhhm" maxlength="50" placeholder="电话号码" style="padding-bottom:4px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5" v-show="isZyfp">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <el-form-item prop="khyh" label="开户银行" :rules="this.isZyfp?kpxxRules.khyh:[{ required: false, message: '请输入开户银行', trigger: 'blur' }]">
                <el-input size="small" v-model="kpxxForm.khyh" placeholder="开户银行"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5" v-show="isZyfp">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <el-form-item prop="yhzh" label="银行账号" :onkeyup="addBlankYhzh()" :rules="this.isZyfp?kpxxRules.yhzh:[{ required: false, message: '请输入银行账号', trigger: 'blur' }]">
                <el-input size="small" v-model="kpxxForm.yhzh" placeholder="银行账号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row style="text-align: center;">
            <span class="mr5 vbm yxLabel" style="color: red;font-size:16px">*注：此处公司地址指的是开具发票抬头上的单位地址</span>
          </el-row>
          <el-row class="buttonSubmit">
            <el-col :span="24">
              
              <el-button v-if="kpxxData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">取消</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitKpxx('kpxxForm')">保存</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </div>

  <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
    <div id="qykpxx" class="mb5">
      <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="21">
            <el-row class="mb10">
              <strong>开票公司名称：</strong>
              <span v-text="kpxxData.kpgsmc||'无'"></span>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>开票类型：</strong>
                <span v-text="kpxxData.kplxmc||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>统一社会信用代码：</strong>
                <span v-text="kpxxData.tyshxydm||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>公司地址：</strong>
                <span v-text="kpxxData.gsdz||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>电话号码：</strong>
                <span v-text="kpxxData.dhhm||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>开户银行：</strong>
                <span v-text="kpxxData.khyh||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>银行账号：</strong>
                <span v-text="kpxxData.yhzh||'无'"></span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">编辑</el-button>
          </el-col>
      </el-row>
    </div>
  </div>
</div>

</template>

<script>
export default {
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  
  name: "kpxxEdit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //开票信息表单
      kpxxForm: {
        uuid:"",
        kplx: "",
        kpgsmc: "",
        tyshxydm: "",
        gsdz: "",
        dhhm: "",
        dhhmqh:"",
        khyh: "",
        yhzh: ""
      },
      //增值税专用发票flag
      isZyfp: false,
      kpxxRules: {
        kplx: [
          { required: true, message: "请选择开票类型", trigger: "change" }
        ],
        kpgsmc: [
          { required: true, message: "请输入开票公司名称", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        tyshxydm: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z0-9 ]+$/,
            message: "只能输入数字和字母",
            trigger: "blur"
          },
          {
            min: 22,
            max: 22,
            message: "请输入18位统一社会信用代码（不包含空格）",
            trigger: "blur"
          }
        ],
        gsdz: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
          { min: 1, max: 150, message: "最多可输入150个字", trigger: "blur" }
        ],
        dhhm: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
        //  { pattern: /^[0-9 ]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 50, message: "最多输入50个字", trigger: "blur" }
        ],
        dhhmqh: [
          { required: true, message: "请输入区号", trigger: "blur" },
        //  { pattern: /^[0-9 ]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 10, message: "最多输入10个字", trigger: "blur" }
        ],
        khyh: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
          { min: 1, max: 50, message: "最多可输入50个字", trigger: "blur" }
        ],
        yhzh: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
          { pattern: /^[0-9 ]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 0, max: 40,message: "最多可输入40位银行账号",trigger: "blur" }
        ]
      },

      editFlag: false,
      //企业开票信息
      kpxxData: {},
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findKpxxByQyid(this.qyid);
      }
    }
  },
  created: function() {
    //this.findKpxxByQyid(this.qyid);
  },
  methods: {
    //通过企业id查找开票信息
    findKpxxByQyid: function(qyid) {
      let vm = this;
      vm.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qykpxx/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            vm.kpxxData = JSON.parse(JSON.stringify(res.data.result[0]));
            //统一社会信用代码格式化
            vm.kpxxData.tyshxydm = vm.longNumFormat(vm.kpxxData.tyshxydm);
            //银行账户格式化
            vm.kpxxData.yhzh = vm.longNumFormat(vm.kpxxData.yhzh);



            let tempForm = res.data.result[0];
            //电话号码区号拆分
            if(tempForm.dhhm != null && tempForm.dhhm !='' && tempForm.dhhm != undefined){
              let dhhmStr = tempForm.dhhm.split("-");
              if(dhhmStr.length == 1){
                tempForm.dhhm = dhhmStr[0];
              }else if(dhhmStr.length > 1){
                tempForm.dhhmqh = dhhmStr[0];
                tempForm.dhhm = dhhmStr[1];
              }
            }
            vm.kpxxForm = tempForm;
            if (vm.kpxxForm.kplx == "1") {
              //专票
              vm.isZyfp = true;
            }else{
              vm.isZyfp = false;
            }

            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
              }else{
                vm.editFlag = true;
              }
          } else {
            vm.editFlag = true;
            vm.kpxxForm =  {
              uuid:"",
              kplx: "",
              kpgsmc: "",
              tyshxydm: "",
              gsdz: "",
              dhhm: "",
              dhhmqh:"",
              khyh: "",
              yhzh: ""
            };
          }
          vm.$emit("getLoading", false);
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    addBlankYhzh: function() {
      if (
        this.kpxxForm.yhzh != undefined &&
        this.kpxxForm.yhzh != "" &&
        this.kpxxForm.yhzh != null
      ) {
        this.kpxxForm.yhzh = this.kpxxForm.yhzh
          .replace(/\s/g, "")
          .replace(/(\w{4})(?=\w)/g, "$1 ");
      }
    },
    addBlankXydm: function() {
      if (
        this.kpxxForm.tyshxydm != undefined &&
        this.kpxxForm.tyshxydm != "" &&
        this.kpxxForm.tyshxydm != null
      ) {
        this.kpxxForm.tyshxydm = this.kpxxForm.tyshxydm
          .replace(/\s/g, "")
          .replace(/(\w{4})(?=\w)/g, "$1 ");
      }
    },
     //发票类型change
    fplxChange: function() {
      if (this.kpxxForm.kplx == "1") {
        //增值税专用发票
        this.isZyfp = true;
      } else {
        this.isZyfp = false;
        this.kpxxForm.dhhm = "";
        this.kpxxForm.khyh = "";
        this.kpxxForm.yhzh = "";
        this.kpxxForm.dhhmqh = "";
      }
    },
   
    //开票信息提交（下一步）
    /* modify by yushch 2022-10-08
    submitKpxx: function(formName) {
      let vm = this;
      vm.$refs[formName].validate(valid => {
        if (valid) {
          vm.$emit("getLoading", true);
          //统一社会信用代码唯一性校验 add by yushch 20200409
          let tyshxydm = vm.kpxxForm.tyshxydm.replace(/ /g, "");
          var params = {
            tyshxydm: tyshxydm,
            deleteFlag: "N"
          };
          vm.$axios.post("/qykpxx/list", params).then(
            function(res) {
              if (res.data.result.length == 0 || (res.data.result.length == 1 && res.data.result[0].qyid == vm.qyid)) {
                var yhzh_str = null;
                if (vm.kpxxForm.yhzh != null && vm.kpxxForm.yhzh != "" && vm.kpxxForm.yhzh != undefined) {
                  yhzh_str = vm.kpxxForm.yhzh.replace(/ /g, "");
                } else {
                  yhzh_str = "";
                }
                if (vm.kpxxStatus == 0) {
                  //新增
                  var params = {
                    qyid: vm.qyid,
                    kplx: vm.kpxxForm.kplx,
                    kpgsmc: vm.kpxxForm.kpgsmc,
                    tyshxydm: tyshxydm,
                    gsdz: vm.kpxxForm.gsdz,
                    khyh: vm.kpxxForm.khyh,
                    yhzh: yhzh_str,
                    deleteFlag: "N",
                    cjrid: vm.currentUser.userid,
                    cjrmc: vm.currentUser.username
                  };
                  if(vm.kpxxForm.dhhmqh == null || vm.kpxxForm.dhhmqh == '' || vm.kpxxForm.dhhmqh == undefined){
                    params.dhhm = vm.kpxxForm.dhhm;
                  }else{
                    params.dhhm = vm.kpxxForm.dhhmqh+'-'+vm.kpxxForm.dhhm;
                  }
                  vm.$axios.post("/qykpxx/doInsertKpxxByVO", params).then(
                    function(res) {
                      if (res.data.result != null && res.data.result != "") {
                        vm.$message({
                          message: "企业开票信息暂存成功",
                          type: "success"
                        });
                        vm.kpUuid = res.data.result.uuid;
                        vm.$emit("getLoading", false);
                        this.$emit("getActive",  2);
                        vm.kpxxStatus = 1;
                        if (vm.qyid != null && vm.qyid != "") {
                          vm.findWjdcByQyid(vm.qyid);
                        }
                      } else {
                        vm.$message({
                          message: "企业开票信息暂存失败",
                          type: "error"
                        });
                        vm.$emit("getLoading", false);
                      }
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
                } else {
                  //修改
                  var params = {
                    uuid: vm.kpUuid,
                    kplx: vm.kpxxForm.kplx,
                    kpgsmc: vm.kpxxForm.kpgsmc,
                    tyshxydm: tyshxydm,
                    gsdz: vm.kpxxForm.gsdz,
                    khyh: vm.kpxxForm.khyh,
                    yhzh: yhzh_str,
                    xgrid: vm.currentUser.userid,
                    xgrmc: vm.currentUser.username
                  };
                  if(vm.kpxxForm.dhhmqh == null || vm.kpxxForm.dhhmqh == '' || vm.kpxxForm.dhhmqh == undefined){
                    params.dhhm = vm.kpxxForm.dhhm;
                  }else{
                    params.dhhm = vm.kpxxForm.dhhmqh+'-'+vm.kpxxForm.dhhm;
                  }
                  vm.$axios.post("/qykpxx/doUpdateByVO", params).then(
                    function(res) {
                      if (res.data.result > 0) {
                        vm.$message({
                          message: "企业开票信息暂存成功",
                          type: "success"
                        });
                        vm.$emit("getLoading", false);
                        this.$emit("getActive",  2);
                       
                        if (vm.qyid != null && vm.qyid != "") {
                          vm.findWjdcByQyid(vm.qyid);
                        }
                      } else {
                        vm.$message({
                          message: "企业开票信息暂存失败",
                          type: "error"
                        });
                        vm.$emit("getLoading", false);
                      }
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
                }
              }else{
                vm.$emit("getLoading", false);
                vm.$message.error("统一社会信用代码已被使用");
              }
            }.bind(vm),
            function(error) {
              vm.$emit("getLoading", false);
              console.log(error);
            }
          );

        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
    },*/
    submitKpxx: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("保存失败，请先填写企业基本信息后再填写其他信息", '提示', {
          confirmButtonText: '确定'
        });
      }else{
        vm.$refs[formName].validate(valid => {
        if (valid) {
          vm.$emit("getLoading", true);
          //统一社会信用代码唯一性校验 add by yushch 20200409
          let tyshxydm = vm.kpxxForm.tyshxydm.replace(/ /g, "");
          var params = {
            tyshxydm: tyshxydm,
            deleteFlag: "N"
          };
          vm.$axios.post("/qykpxx/list", params).then(
            function(res) {
              if (res.data.result.length == 0 || (res.data.result.length == 1 && res.data.result[0].qyid == vm.qyid)) {
                var yhzh_str = null;
                if (vm.kpxxForm.yhzh != null && vm.kpxxForm.yhzh != "" && vm.kpxxForm.yhzh != undefined) {
                  yhzh_str = vm.kpxxForm.yhzh.replace(/ /g, "");
                } else {
                  yhzh_str = "";
                }
                var params = {
                  uuid: vm.kpxxForm.uuid,
                  qyid: vm.qyid,
                  kplx: vm.kpxxForm.kplx,
                  kpgsmc: vm.kpxxForm.kpgsmc,
                  tyshxydm: tyshxydm,
                  gsdz: vm.kpxxForm.gsdz,
                  khyh: vm.kpxxForm.khyh,
                  yhzh: yhzh_str,
                  xgrid: vm.currentUser.userid,
                  xgrmc: vm.currentUser.username,
                  validateFlag: 'T'
                };
                if(vm.kpxxForm.dhhmqh == null || vm.kpxxForm.dhhmqh == '' || vm.kpxxForm.dhhmqh == undefined){
                    params.dhhm = vm.kpxxForm.dhhm;
                }else{
                    params.dhhm = vm.kpxxForm.dhhmqh+'-'+vm.kpxxForm.dhhm;
                }
                vm.$axios.post("/qykpxx/doInsertOrUpdateKpxxByVO",params).then(
                    function(res) {
                      if (res.data.result != null && res.data.result != "") {
                        vm.$message({
                          message: "企业开票信息暂存成功",
                          type: "success"
                        });
                        vm.$emit("getLoading", false);
                        //this.$emit("getActive",  2);

                        vm.editFlag = false;
                        this.findKpxxByQyid(this.qyid);
                      } else {
                        vm.$message({
                          message: "企业开票信息暂存失败",
                          type: "error"
                        });
                        vm.$emit("getLoading", false);
                      }
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );

              }else{
                vm.$emit("getLoading", false);
                vm.$message.error("统一社会信用代码已被使用");
              }
            }.bind(vm),
            function(error) {
              vm.$emit("getLoading", false);
              console.log(error);
            }
          );

        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
    
      }
      },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findKpxxByQyid(this.qyid);
    }
  }
};
</script>

<style lang="scss">
#kpxxEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEdit/Kpxx.vue